const customer = require("./customer.service");
const customerListAddress = require("./customerListAddress.service");
const customerProfile = require("./customerProfile.service");
const marketBusinessCatalogue = require("./marketBusinessCatalogue.service");
const marketCart = require("./marketCart.service");
const marketCoupon = require("./marketCoupon.service");
const marketOrder = require("./marketOrder.service");
const marketProductReviews = require("./marketProductReviews.service");
const login = require("./login.service");
const marketTransaction = require("./marketTransaction.service");
const marketCustomerCatalogue = require("./marketCustomerCatalogue.service");
const merchantDeveloperWebhook = require("./merchantDeveloperWebhook.service");
const favourites = require("./favourites.services");
const categories = require("./categories.services");
const services = require("./services.services");
const newCategories = require("./newCategories.services");


const productRemarks = require("./productRemarks.service");
const payment = require("./payment.service");
const deliveryProviders = require("./marketDeliveryProviders");
module.exports = {
  customer,
  customerListAddress,
  customerProfile,
  newCategories,
  marketBusinessCatalogue,
  marketCart,
  marketCoupon,
  categories,
  marketOrder,
  services,
  favourites,
  marketProductReviews,
  marketTransaction,
  login,
  marketCustomerCatalogue,
  merchantDeveloperWebhook,
  payment,
  productRemarks,
  deliveryProviders,
};
